/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../api/types.generated";
export type GetVolunteerSelfQueryVariables = Types.Exact<{
  event_id: Types.Scalars["Int"];
}>;

export type GetVolunteerSelfQuery = {
  volunteerSelf: Pick<
    Types.Volunteer,
    | "min_primary_signups"
    | "primary_category_name"
    | "read_handbook"
    | "volunteer_hours"
  >;
};

export const GetVolunteerSelfDocument = gql`
  query GetVolunteerSelf($event_id: Int!) {
    volunteerSelf(event_id: $event_id) {
      min_primary_signups
      primary_category_name
      read_handbook
      volunteer_hours
    }
  }
`;

/**
 * __useGetVolunteerSelfQuery__
 *
 * To run a query within a React component, call `useGetVolunteerSelfQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVolunteerSelfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVolunteerSelfQuery({
 *   variables: {
 *      event_id: // value for 'event_id'
 *   },
 * });
 */
export function useGetVolunteerSelfQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetVolunteerSelfQuery,
    GetVolunteerSelfQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    GetVolunteerSelfQuery,
    GetVolunteerSelfQueryVariables
  >(GetVolunteerSelfDocument, baseOptions);
}
export function useGetVolunteerSelfLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetVolunteerSelfQuery,
    GetVolunteerSelfQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    GetVolunteerSelfQuery,
    GetVolunteerSelfQueryVariables
  >(GetVolunteerSelfDocument, baseOptions);
}
export type GetVolunteerSelfQueryHookResult = ReturnType<
  typeof useGetVolunteerSelfQuery
>;
export type GetVolunteerSelfLazyQueryHookResult = ReturnType<
  typeof useGetVolunteerSelfLazyQuery
>;
export type GetVolunteerSelfQueryResult = ApolloReactCommon.QueryResult<
  GetVolunteerSelfQuery,
  GetVolunteerSelfQueryVariables
>;
